import contentApiClient from './contentApiClient';
import { responseWithErrorHandler } from '.';
import type { NewUserData } from '@/models/NewUserData';

export const createUser = (user: NewUserData) => {
	const data: Promise<Response> = contentApiClient.client.post('user', {
		headers: {
			'api-version': '3.2',
		},
		json: user,
	}).json();

	return responseWithErrorHandler(data);
};
